export default __webpack_public_path__ + "images/0e7429a113acffdc28a2105940edbcb4.png";